var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.image)?_c('div',{staticClass:"image-button__image"},[_c('img',{attrs:{"src":_vm.image}})]):_vm._e(),(_vm.label)?_c('div',{staticClass:"image-button__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }